export const GECOAIR_HOST = location.protocol + "//" + location.host;
